import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import IframeComm from "react-iframe-comm";
import Select from "react-select";
import * as _ from "lodash";
import Editor from "../../editor/editor";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { ChromePicker } from 'react-color'
import localStore from 'src/utils/local-storage'
import Uploader from '../../util/uploader';
import CkService from "src/services/CkService";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify'
import spellCheck from 'src/utils/spell-check';
import SpellError from 'src/components/util/spell-error';
import TuNhayCamWarning from 'src/components/util/tu-nhay-cam-warning';
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import uploadImageByUrl from "src/utils/uploadImageByUrl";
import { Alert } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import countWordsHTML from 'src/utils/countWordsHTML';
import fetchAiRecommend from "../../../utils/AiRecommend.jsx";

class ContentTab extends Component {
  constructor(props) {
    super(props);
    const _user = localStore.get('_user');
    const aiLimitWords = localStore.get("_aiLimitWord");
    this.state = {
      currentPost: null,
      error: true,
      editorType: [
        { type: "normal", label: "Bài viết thường", value: "normal" },
        { type: "special", label: "Bài đặc biệt", value: "special" },
        { type: "mini", label: "Bài viết mini", value: "mini" },
        ...(_user.can_create_video_post ? [{ type: "video", label: "Bài viết video", value: "video" }] : []),
        ...(_user.can_create_podcast_post ? [{ type: "podcast", label: "Podcast", value: "podcast" }] : []),
        ...(_user.can_create_short_post ? [{ type: "short", label: "Short", value: "short" }] : [])        
      ],
      editorTypeSelected: {
        type: "normal",
        label: "Bài viết thường",
        value: "normal"
      },
      styleColorBackGround: '#fff',
      styleImageBackGround: '',
      crop_ver: {
        unit: 'px',
        width: 660,
        aspect: 1,
        x: 0,
        y: 0,
      },
      spellData: {},
      listTab: {},
      showAiRecommend: false,
      showNoContentModal: false,
      lengthContent: (aiLimitWords && aiLimitWords.content) ? aiLimitWords.content : 200,
      isLoading: false,
      showModalSpellCheck: false,
      spellCheckLists: [],
      tempContentBase64: null
    };

    this.colorPickerRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick)
  }

  componentWillUnmount() {
    // important
    document.removeEventListener('click', this.handleClick)
  }

  handleClick = (event) => {
    const { target } = event
    if (!this.colorPickerRef.current.contains(target)) {
      // let { stylePicker } = this.state;
      this.setState({ stylePicker: false });
    }
  }

  UNSAFE_componentWillMount() {
    const {
      post: { currentPost }
    } = this.props;
    let { editorType, editorTypeSelected } = this.state;
    
    if (currentPost.editor_type) {
      editorTypeSelected = _.find(editorType, type => {
        return type.type == currentPost.editor_type;
      });
    } else {
      currentPost.editor_type = "normal";
      this.props.setCurrentPost(currentPost);
    }

    this.setState({
      currentPost, editorTypeSelected, styleColorBackGround: currentPost.content_background
      , styleImageBackGround: currentPost.content_image
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      post: nextPost,
      fields: nextFields,
      currenttab: nextTab
    } = nextProps;
    const { fields, post, typepage, currenttab: currentTab } = this.props;
    if (post.currentTabPost === 4 && nextPost.currentTabPost !== 4) {
      const { currentPost } = nextPost;
      // console.log(currentPost);
      this.props.setCurrentPost(currentPost);
      let { editorType, editorTypeSelected } = this.state;
      if (currentPost.editor_type) {
        editorTypeSelected = _.find(editorType, type => {
          return type.type == currentPost.editor_type;
        });

      } else {
        currentPost.editor_type = "normal";
        this.props.setCurrentPost(currentPost);
      }

      this.setState({editorTypeSelected});
    }
    // if(nextPost != post){
    //   console.log("UPDATE EDITOR");
    //   this.props.checkRequireData(nextPost.currentPost, 0);
    // }
    this.setState({
      listTab: nextProps.listTab,
    });
  }

  getValueEditorType = value => {
    this.confirmAction(value);
  };

  handleCreatePost(data) {
    // console.log(data);
    const {
      post: { currentPost }
    } = this.props;
    currentPost.content = data;
    this.props.setCurrentPost(currentPost);
  }

  removeDefaultTag(){
    const { post: { currentPost }, config: { configuration } } = this.props;
    currentPost.tags = currentPost.tags.filter(function(element) {
        if(element.label != 'Special' && element.label != 'Mini special'){
          // console.log(element);
          return element;
        }
    });
    // console.log(currentPost.tags);
    this.props.setCurrentPost(currentPost);
    
  }

  //ticket 140:Tự động gắn tag cho bài special và mini special
  setDefaultTag(type){
    const { post: { currentPost }, config: { configuration } } = this.props;

    let tag_id = _.find(configuration, (conf) => conf.label == `${type}_tag_id`);  

    let filterTag = _.find(currentPost.tags, (tag) => {
      return tag.id == tag_id.value;
    });
    if(!filterTag){
      currentPost.tags = [...currentPost.tags, {_id: tag_id.value, value: tag_id.value, label: tag_id.label}];
      this.props.setCurrentPost(currentPost);
    }
    
  }

  changeBackground = value => {
    const { post: { currentPost } } = this.props;
    currentPost.content_background = value;
    this.props.setCurrentPost(currentPost);
  }
  changeImageBackground = value => {
    const { post: { currentPost } } = this.props;
    currentPost.content_image = value;
    this.setState({ styleImageBackGround: value }, () => {
      this.props.setCurrentPost(currentPost);
    })
  }


  handleColorChange = ({ hex }) => {
    this.setState({ styleColorBackGround: hex })
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.changeBackground(hex);
    }, 1000);

  }

  handleBackground = () => {
    let { stylePicker } = this.state
    this.setState({ stylePicker: !stylePicker });
  }

  handleImageCrop = data => {
    console.log(data);

    // no upload

  }
  noneedcrop = data => {
    const { post: { currentPost } } = this.props
    currentPost.content_image = data.url;
    this.setState({ styleImageBackGround: data.url }, () => {
      this.props.setCurrentPost(currentPost);
      toast.success("Đã chọn ảnh nền");
    })
  }

  // Utility function to convert content to base64
  contentToBase64 = (content) => {
    try {
      return btoa(unescape(encodeURIComponent(content)));
    } catch (e) {
      console.error('Error converting content to base64:', e);
      return '';
    }
  }

  handleCheckSpell = async () => {
    const currentPost = this.props.content;
    const content = currentPost.content;
    
    if(content && countWordsHTML(content) >= this.state.lengthContent) {
      const currentContentBase64 = this.contentToBase64(content);
      
      this.setState({ showModalSpellCheck: true });

      // Compare base64 encoded content
      if (!this.state.tempContentBase64 || currentContentBase64 !== this.state.tempContentBase64) {
        this.setState({ isLoading: true });
        const response = await fetchAiRecommend(content, 'kiem-tra-chinh-ta');
        if(response && response.items && response.items.length > 0) {
          this.setState({
            spellCheckLists: response.items,
            isLoading: false,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      }
      
      // Always update tempContentBase64 after modal opens
      this.setState({ tempContentBase64: currentContentBase64 });
    } else {
      this.setState({ showNoContentModal: true });
      return;
    }
  }

  reloadCheck = async () => {
    const currentPost = this.props.content;
    const content = currentPost.content;
    const currentContentBase64 = this.contentToBase64(content);
    
    this.setState({ isLoading: true, spellCheckLists: [] });
    const response = await fetchAiRecommend(content, 'kiem-tra-chinh-ta');
    if(response && response.items && response.items.length > 0) {
      this.setState({
        spellCheckLists: response.items,
        isLoading: false,
        tempContentBase64: currentContentBase64
      });
    } else {
      this.setState({
        isLoading: false,
        tempContentBase64: currentContentBase64
      });
    }
  }

  handleClose = () => {
    this.setState({ 
      showModalSpellCheck: false,
      showNoContentModal: false 
    });
  }

  handleDaoVan = () => {
    const currentPost = this.props.content;
    const urlCheckDaoVan = "https://smallseotools.com/vi/plagiarism-checker/";
    if(!currentPost) return;
    const contentCurrentPost = currentPost.content;
    if(!contentCurrentPost) return;
    // Tạo 1 DOM tạm để xử lý
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = contentCurrentPost;

    // Xóa hết ảnh và figure
    tempDiv.querySelectorAll('img, video, iframe, figure, figcaption').forEach(el => el.remove());

    // Lấy text còn lại
    const cleanText = tempDiv.innerText.trim();

    navigator.clipboard.writeText(cleanText).then(() => {
      let newWin = window.open(urlCheckDaoVan, '_blank');
      newWin.document.write(
        `<script>alert('Đã sao chép văn bản. Vui lòng dán (Ctrl + V hoặc CMD + V) vào ô kiểm tra đạo văn.');window.location = "${urlCheckDaoVan}"<\/script>`
      );
    });
  }

  handleUpdatePostData = async (data) => {
    if (data) {
      const { title, thumbnail_url } = data;
      const currentPost = this.props.content;
      currentPost.title = title;
      currentPost.description = title;
      currentPost.img_hor = await uploadImageByUrl({
        url: thumbnail_url, 
        title, 
        tmp_id: currentPost.tmp_id,
        editor_type: currentPost.editor_type,
      });
      this.props.changeFieldValue('title', title);        
      this.props.changeFieldValue('description', title);        
      this.props.setCurrentPost(currentPost);
    }
  }

  render() {
    const currentPost = this.props.content;

    let { layoutName, checkClass, channels } = this.props;
    let { listTab } = this.state;
    const type = currentPost.editor_type;
    let typeEditor = this.state.currentPost.editor_type;
    return (
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 " + checkClass}>
            <h4 className="card-title">Nội dung bài viết</h4>
            <div className="card-tools mt-2">
              <button className="btn btn-warning mr-2" onClick={this.handleDaoVan}>Kiểm tra Copy</button>
              <button className="btn btn-ai-recommend" onClick={this.handleCheckSpell}>
                <span className="mr-2">
                <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="16px" height="16px" fill="currentColor" ariaHidden="true"><path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path></svg>
                </span>
                Kiểm tra chính tả
              </button>
            </div>
            <Modal show={this.state.showNoContentModal} onHide={this.handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Thông báo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Chưa có nội dung bài viết hoặc content chưa đủ {this.state.lengthContent} từ, không thể kiểm tra chính tả</p>
              </Modal.Body>
            </Modal>
            <Modal show={this.state.showModalSpellCheck} onHide={this.handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Kiểm tra chính tả</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.isLoading ? (
                  <div className="ai-loading-container">
                      <div className="ai-icon-container">
                          <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="32px" height="32px" fill="#6366f1" ariaHidden="true" className="rotating-icon">
                              <path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path>
                          </svg>
                          <div className="pulse-ring">                                   
                          </div>                                
                      </div>
                      <div className="loading-text">
                          <div className="d-flex align-items-center">AI đang phân tích  
                              <div className="loading-dots" style={{ marginLeft: '10px' }}>
                                  <span>•</span>
                                  <span>•</span>
                                  <span>•</span>
                              </div>
                          </div>
                      </div>                            
                  </div>
                )
                :
                <>
                  {this.state.spellCheckLists.length === 0 ? (
                    <div className="text-center">Không phát hiện lỗi chính tả</div>
                  ) : (
                    <table className="table table-bordered mt-3">
                      <thead>
                        <tr>
                          <th style={{ width: "100px" }}>Từ sai</th>
                          <th style={{ width: "100px" }}>Từ đúng</th>
                          <th>Đoạn sai</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.spellCheckLists.map((item, idx) => (
                          <tr key={`suggestion-${idx}`}>
                            <td>{item.incorrect}</td>
                            <td>{item.correct}</td>
                            <td>{item.context}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  <div className="d-flex justify-content-center mt-5">
                      <button className="btn btn-ai-recommend" onClick={this.reloadCheck}>
                        Kiểm tra lại <i className="fas fa-sync ml-2"></i>
                      </button>
                  </div>
                </>
                }
              </Modal.Body>
            </Modal>
          </div>
        )}

        <div className="card-body col-12">
          <div className="row mb-3">
            <div ref={this.colorPickerRef} className={`col-xl-2 col-lg-6 col-6 col-sm-4 mb-3 align-self-center ml-auto justify-content-between ${(['mini', 'special'].includes(type)) ? 'd-flex' : 'd-none' }`}>
              <button
                onClick={this.handleBackground}
                className={"btn bg-maroon btn-block " + (this.state.styleColorBackGround !== '#fff' ? 'mr-2' : '')}
              >Chọn màu nền</button>

              {
                this.state.styleColorBackGround !== '#fff' &&
                <button
                  onClick={() => this.handleColorChange({ hex: '#fff' })}
                  className="btn btn-inline-block"
                  style={{ backgroundColor: `${this.state.styleColorBackGround}` }}
                ><i className="fas fa-times"></i></button>
              }

              <div className={"position-absolute " + (this.state.stylePicker ? '' : 'd-none')}
                style={{ zIndex: 9999, left: '0px' }}>

                <ChromePicker onChangeComplete={this.handleColorChange} color={this.state.styleColorBackGround} />
              </div>

            </div>

            <div className={`col-xl-2 col-lg-6 col-6 col-sm-4 mb-3 align-self-center ml-auto justify-content-between ${(['mini', 'special'].includes(type)) ? 'd-flex' : 'd-none' }`}>
              <Uploader channels={channels} channel={currentPost.channel} noneedcrop={this.noneedcrop} no_crop={true} tmp_id={currentPost.tmp_id || currentPost.id} url={currentPost.content_image} crop={this.state.crop_ver} type="content_image" handleImageCrop={this.handleImageCrop} styleImageBackGround={this.state.styleImageBackGround} />

              {
                this.state.styleImageBackGround !== '' &&
                <button
                  onClick={(e) => {
                    // this.setState({ styleImageBackGround: '' })

                    this.changeImageBackground('')

                  }}
                  className="btn btn-inline-block"
                  style={{ backgroundImage: `url('${this.state.styleImageBackGround}')` }}
                ><i className="fas fa-times"></i></button>
              }

            </div>
          </div>

          <div className="row">

            {/* <SpellError 
              spellData={this.state.spellData} 
              className="col-12"
            />       */}

                 
            
            <div className={"col-12 overflow-hidden " + currentPost.editor_type + " editor-" + currentPost.editor_type} >
              <Editor
                channel={currentPost.channel}
                channels={channels}
                post={currentPost}
                editorTypeSelected={this.state.editorTypeSelected}
                styleColorBackGround={this.state.styleColorBackGround}
                styleImageBackGround={this.state.styleImageBackGround}
                onChange={content => {
                  this.onContentChange(content);
                }}
                onBlur={content => {
                  console.log('onBlur');
                  //check Nội dung
                  this.props.checkRequireData(currentPost, 3);
                  //check h3 (Subtitle - Subheading) tag.
                  this.props.checkRequireData(currentPost, 19);
                  //check Nội dung External link
                  this.props.checkRequireData(currentPost, 10);
                  //check Nội dung Internal link
                  this.props.checkRequireData(currentPost, 15);
                  // check External Image
                  this.props.checkRequireData(currentPost, 11);
                  if(currentPost.editor_type == 'video' || currentPost.editor_type == 'short'){
                    this.props.checkRequireData(currentPost, 12);
                  }
                  // spellCheck(content).then(data => {
                  //   this.setState({
                  //     spellData: data
                  //   })
                  // })                  
                }}
                handleUpdatePostData={this.handleUpdatePostData}
              />
              {/* <div className={`text-info`}>
                <Alert variant="info">
                  <p className="mb-0">@ dùng để chèn Bài Podcast, Video</p>
                  <p className="mb-0"># dùng để chèn link Xem thêm</p>
                </Alert>
              </div> */}
            </div>
            <TuNhayCamWarning
              listTab={listTab}
              className="col-12"
            /> 
          </div>
        </div>
      </div>
    );
  }

  onContentChange(content) {
    let currentPost = this.props.content;
    currentPost.content = content;
    this.props.setCurrentPost(currentPost);
    this.props.handleCheckExternalIMGError();
  }
}

export default connect(
  store => {
    return {
      post: store.post,
      config: store.config
    };
  },
  dispatch => {
    return {
      setCurrentPost: value => {
        dispatch(postActions.setCurrentPost(value));
      },
      changeFieldValue: (field, value) => { dispatch(change('formPostEdit', field, value)) },
    };
  }
)(ContentTab);
